import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ConfigurationProvider } from '~/contexts/ConfigurationProvider';
import { useAuth } from './AuthProvider';

export function ProtectedRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  return (
    <ConfigurationProvider>
      <Outlet />
    </ConfigurationProvider>
  );
}
